module.exports = __webpack_public_path__ + "img/aam-panna.ea581b21.jpg";